import React from "react";
import Comingsoonpage from "../../../common/Comingsoon";

const NonRevMovement = () => {
  return (
    <div>
      <Comingsoonpage />
    </div>
  );
};

export default NonRevMovement;
